import React, { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import augur_white from '../assets/images/icon_white.png';

interface LayoutProps {
  children: ReactNode;
}

const Layout = ({ children }: LayoutProps) => {
  return (
    <div className="min-h-screen flex flex-col">
      {/* Header - fixed height */}
      <header className="flex-none bg-black text-white py-1.5 px-3 flex items-center justify-between">
        <div className="flex items-center space-x-2">
          <div className="h-8 flex items-center">
            <img
              src={augur_white}
              alt="Augur Logo"
              className="h-full w-auto object-contain"
            />
          </div>
          <span className="font-bold text-xl">Augur Edge</span>
        </div>
        <nav className="flex items-center space-x-6">
          <Link to="/" className="hover:text-orange-500 transition-colors">Camera</Link>
          <Link to="/analytics" className="hover:text-orange-500 transition-colors">Analytics</Link>
          <Link to="/settings" className="hover:text-orange-500 transition-colors">Settings</Link>
        </nav>
      </header>

      {/* Main content - scrollable */}
      <main className="flex-1 overflow-y-auto">
        {children}
      </main>

      {/* Footer - fixed height */}
      <footer className="flex-none bg-black text-white py-1 px-6">
        <div className="container mx-auto flex justify-between items-center">
          <span>© {new Date().getFullYear()} Augur Initiative. All rights reserved.</span>
          <div className="space-x-4">
            <Link to="/privacy" className="hover:text-orange-500 transition-colors">Privacy Policy</Link>
            <Link to="/terms" className="hover:text-orange-500 transition-colors">Terms of Service</Link>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Layout;